import React from "react";
import { NavigationContextInterface } from "types/tags";

export const NavigationContext =
  React.createContext<NavigationContextInterface>({
    navigationSets: [],
    infoPageNavItems: [],
  });
